module.exports = __webpack_public_path__ + "img/vol05_character_img01_sp.8e2a4094.png";